import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosHttp from "services/axiosHttp";

export const reviewPettyCashRequests = createAsyncThunk(
	"reviewPettyCashRequests",
	async ({ requestIds, review_status_id }, { rejectWithValue }) => {
		try {
			const response = await axiosHttp.put("petty-cash/requests/review", {
				requestIds,
				review_status_id,
			});
			return response.data;
		} catch (err) {
			if (!err.response) {
				throw err;
			}
			return rejectWithValue(err.response.data);
		}
	},
);

const PettyCashRequestReviewSlice = createSlice({
	name: "PettyCashRequestReviewSlice",
	initialState: {
		isLoading: false,
		isError: false,
		error: null,
		data: null,
	},
	reducers: {
		resetPettyCashRequestReviewState: (state) => {
			state.isLoading = false;
			state.isError = false;
			state.error = null;
			state.data = null;
		},
	},
	extraReducers: (builder) => {
		builder.addCase(reviewPettyCashRequests.pending, (state) => {
			state.isLoading = true;
			state.isError = false;
			state.error = null;
		});
		builder.addCase(reviewPettyCashRequests.fulfilled, (state, action) => {
			state.isLoading = false;
			state.isError = false;
			state.data = action.payload;
		});
		builder.addCase(reviewPettyCashRequests.rejected, (state, action) => {
			state.isLoading = false;
			state.isError = true;
			state.error = action.payload;
		});
	},
});

export const { resetPettyCashRequestReviewState } = PettyCashRequestReviewSlice.actions;
export default PettyCashRequestReviewSlice.reducer;
